import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivosComponent } from './activos/activos.component';
import { CompraVentaComponent } from './compra-venta/compra-venta.component';
import { AuthGuard } from 'app/auth/helpers';
import { RouterModule } from '@angular/router';
import { ContentHeaderModule } from 'app/layout/components/content-header/content-header.module';
import { TranslateModule } from '@ngx-translate/core';
import { CoreCommonModule } from '@core/common.module';
import { NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';

const routes = [
  {
    path: 'bitso/compraventa',
    component: CompraVentaComponent,
    data: { animation: 'activos' },
    canActivate: [AuthGuard]
  },
  {
    path: 'bitso',
    component: ActivosComponent,
    data: { animation: 'bitso' },
    canActivate: [AuthGuard]
  }
];


@NgModule({
  declarations: [ ActivosComponent, CompraVentaComponent ],
  imports: [RouterModule.forChild(routes), ContentHeaderModule, TranslateModule, CoreCommonModule, NgbAlertModule],
  exports: [ActivosComponent, CompraVentaComponent]
})
export class BitsoModule { }
